import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Navbar } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import GuestLogoutButton from "./GuestLogoutButton";

const GuestNavbar: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;

  return (
    <>
      <Navbar
        className={classNames("p-0", theme!.headerColor)}
        expand="md"
        style={{ height: "40px" }}
      >
        <div
          className={classNames(
            "ml-2 navbarText text-truncate navbar-brand",
            theme!.headerTextColor
          )}
        ></div>

        <div className="ml-auto"></div>
        {/* <strong className={classNames("mr-2", theme!.headerTextColor)}>
          {guestUsername}
        </strong> */}
        <GuestLogoutButton />
      </Navbar>
    </>
  );
};

export default observer(GuestNavbar);
